import React, {createContext, useState} from "react";
import Notification from "../../components/common/Notification";
import PMSPrescriptionSettingsServices from "../../services/pms_services/PMSPrescriptionSettingsServices";

export const PMSPrescriptionSettingsContext = createContext("PMSPrescriptionSettingsContext");

const PMSPrescriptionSettingsContextProvider = ({children}) => {

    const [prescriptionSettings, setPrescriptionSettings] = useState(null);
    const [loading, setLoading] = useState(false);

    const getPrescriptionSettingsByPharmacyId = async (id) => {
        setLoading(true);
        try {
            const res = await PMSPrescriptionSettingsServices.getPrescriptionSettingsByPharmacyId(id);
            setPrescriptionSettings(res.data);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            let _error = "Something went wrong.";
            if (error.message === 'Network Error') _error = error.message;
            if (error.response && error.response.data) _error = error.response.data.message;
            Notification("error", "ERROR", `${_error}`);
            return false;
        }
    };

    const getPrescriptionByDoctor = async () => {
        setLoading(true);
        try {
            const res = await PMSPrescriptionSettingsServices.getPrescriptionByDoctor();
            setPrescriptionSettings(res.data);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            let _error = "Something went wrong.";
            if (error.message === 'Network Error') _error = error.message;
            if (error.response && error.response.data) _error = error.response.data.message;
            Notification("error", "ERROR", `${_error}`);
            return false;
        }
    };

    const savePrescriptionSettings = async (data, id) => {
        setLoading(true);
        try {
            const res = await PMSPrescriptionSettingsServices.savePrescriptionSettings(data, id);
            setPrescriptionSettings(res.data);
            Notification("success", "Updated", "Prescription Settings have been updated successfully");
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            let _error = "Something went wrong.";
            if (error.message === 'Network Error') _error = error.message;
            if (error.response && error.response.data) _error = error.response.data.message;
            Notification("error", "ERROR", `${_error}`);
            return false;
        }
    };

    return (
        <PMSPrescriptionSettingsContext.Provider
            value={{
                prescriptionSettings,
                loading,
                getPrescriptionSettingsByPharmacyId,
                getPrescriptionByDoctor,
                savePrescriptionSettings,
            }}
        >
            {children}
        </PMSPrescriptionSettingsContext.Provider>
    );
};

export default PMSPrescriptionSettingsContextProvider;
